import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const factors = [
  { title: "Global Expertise", icon: "Globe", value: "20+", label: "Cross-Border Markets" },
  { title: "Strategic Execution", icon: "Cpu", value: "98%", label: "Transaction Success" },
  { title: "Confidential Advisory", icon: "Shield", value: "100%", label: "Client Privacy" },
  { title: "Growth Focused", icon: "BarChart", value: "15x", label: "Average ROI Impact" }
];

const MAWhyUs = () => {
  return (
    <section className="py-24 bg-brand-gray relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-brand-black mb-8">Why White Knight Global</h2>
            <div className="space-y-8">
              {factors.map((item, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start gap-6"
                >
                  <div className="mt-1 flex-shrink-0 w-12 h-12 bg-white border border-brand-border rounded flex items-center justify-center text-brand-gold shadow-sm">
                    <SafeIcon name={item.icon} className="text-xl" />
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-brand-black mb-1">{item.title}</h4>
                    <p className="text-brand-muted text-sm font-light">Institutional knowledge combined with agile, independent strategic execution.</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2 grid grid-cols-2 gap-4">
            {factors.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className="p-8 bg-brand-black text-white rounded-sm text-center"
              >
                <div className="text-4xl font-bold text-brand-gold mb-2">{item.value}</div>
                <div className="text-xs tracking-widest uppercase text-gray-500 font-bold">{item.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MAWhyUs;